<template>
    <div>

        <table class="table table-striped table-bordered w-100 tabla-default">
            <thead>
                <tr>
                    <th>Fecha hora</th>
                    <th>Número de teléfono</th>
                    <th>Rut asegurado</th>
                    <th>Resultado de la gestión</th>
                    <th>Detalle de error</th>
                    <th>Producto</th>
                    <th>Porcentaje de avance</th>
                    <th>Canal</th>
                    <th>Opciones Encontradas</th>
                    <th>Rapidez Servicio</th>
                    <th>Evaluación del Servicio</th>
                    <th>Comentarios</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="interaccion in interacciones[0]">
                    <td>{{ interaccion.created_at }}</td>
                    <td>{{ interaccion.emisor }}</td>
                    <td>{{ interaccion.asegurado }}</td>
                    <td>{{ interaccion.resultado }}</td>
                    <td>{{ interaccion.error }}</td>
                    <td>{{ interaccion.producto }}</td>
                    <td>{{ interaccion.avance }}</td>
                    <td v-if="interaccion.receptor === 'WEBCHAT'">ChatBot</td>
                    <td v-else> WhatsApp </td>
                    <td>{{ interaccion.opciones_encontradas }}</td>
                    <td>{{ interaccion.rapidez_servicio }}</td>
                    <td>{{ interaccion.evaluacion_servicio }}</td>
                    <td>{{ interaccion.comentarios_servicio }}</td>
                </tr>
            </tbody>
        </table>
        <h3>
            Distribución de opciones seleccionadas
        </h3>
        <div class="row">
            <div class="col-lg-2 col-sm-12">
                <button type="button" class="btn p-0 btn-block" style="opacity: 1 !important" disabled>
                    <div class="widget gray-bg" style="background-color: #b5b5b5">
                        <span> Reembolsos </span>
                        <h2 class="font-bold">{{ interacciones[1][0].Reembolsos }}</h2>
                    </div>
                </button>
            </div>
            <div class="col-lg-2 col-sm-12">
                <button type="button" class="btn p-0 btn-block" style="opacity: 1 !important" disabled>
                    <div class="widget gray-bg" style="background-color: #b5b5b5">
                        <span> Seguro de viaje </span>
                        <h2 class="font-bold">{{ interacciones[1][0].Seguros }}</h2>
                    </div>
                </button>
            </div>
            <div class="col-lg-2 col-sm-12">
                <button type="button" class="btn p-0 btn-block" style="opacity: 1 !important" disabled>
                    <div class="widget gray-bg" style="background-color: #b5b5b5">
                        <span> Productos </span>
                        <h2 class="font-bold">{{ interacciones[1][0].Productos }}</h2>
                    </div>
                </button>
            </div>
            <div class="col-lg-2 col-sm-12">
                <button type="button" class="btn p-0 btn-block" style="opacity: 1 !important" disabled>
                    <div class="widget gray-bg" style="background-color: #b5b5b5">
                        <span> Operadora </span>
                        <h2 class="font-bold">{{ interacciones[3][0].Operadoras }}</h2>
                    </div>
                </button>
            </div>
            <div class="col-lg-2 col-sm-12">
                <button type="button" class="btn p-0 btn-block" style="opacity: 1 !important" disabled>
                    <div class="widget gray-bg" style="background-color: #b5b5b5">
                        <span> Total Servicios</span>
                        <h2 class="font-bold">{{ interacciones[4] }}
                        </h2>
                    </div>
                </button>
            </div>
        </div>
        <h3>
            Distribución de encuestas
        </h3>
        <div class="row">
            <div class="col-lg-2 col-sm-12">
                <button type="button" class="btn p-0 btn-block" style="opacity: 1 !important" disabled>
                    <div class="widget gray-bg" style="background-color: #b5b5b5">
                        <span> Total Encuestas Iniciadas </span>
                        <h2 class="font-bold">{{ interacciones[2].cantidad_total }}</h2>
                    </div>
                </button>
            </div>
            <div class="col-lg-2 col-sm-12">
                <button type="button" class="btn p-0 btn-block" style="opacity: 1 !important" disabled>
                    <div class="widget gray-bg" style="background-color: #b5b5b5">
                        <span> Rapidez Servicio </span>
                        <h2 class="font-bold">{{ interacciones[2].opciones_encontradas }}</h2>
                    </div>
                </button>
            </div>
            <div class="col-lg-2 col-sm-12">
                <button type="button" class="btn p-0 btn-block" style="opacity: 1 !important" disabled>
                    <div class="widget gray-bg" style="background-color: #b5b5b5">
                        <span> Opciones Encontradas </span>
                        <h2 class="font-bold">{{ interacciones[2].rapidez_servicio }}</h2>
                    </div>
                </button>
            </div>
            <div class="col-lg-2 col-sm-12">
                <button type="button" class="btn p-0 btn-block" style="opacity: 1 !important" disabled>
                    <div class="widget gray-bg" style="background-color: #b5b5b5">
                        <span> Evaluación Servicio </span>
                        <h2 class="font-bold">{{ interacciones[2].evaluacion_servicio }}</h2>
                    </div>
                </button>
            </div>
            <div class="col-lg-2 col-sm-12">
                <button type="button" class="btn p-0 btn-block" style="opacity: 1 !important" disabled>
                    <div class="widget gray-bg" style="background-color: #b5b5b5">
                        <span> Total Encuestas Completas </span>
                        <h2 class="font-bold">{{ interacciones[2].cantidad_total_respondidas }}</h2>
                    </div>
                </button>
            </div>
        </div>

    </div>
</template>
    
<script>

export default {
    name: "ReporteBiceVida",
    props: ["interacciones"],
    components: {
    },
    data: function () {
        return {
        };
    },
    mounted: function () {
        // console.log('mounted');
    },
    methods: {
    }
};
</script>